import RetailModel from 'app/src/data/models/RetailModel';
import URLHelper from 'app/src/data/models/utils/URLHelper';
import Format from 'app/src/data/Format';
import $ from 'jquery';

export default class CCGateway extends RetailModel {
  // Server uses the ccGatewayID field as the model's unique identifier. This
  // informs the Backbone.Model of this fact.
  get idAttribute() {
    return 'ccGatewayID';
  }

  get defaults() {
    return {
      name: '',
      marketType: 0,
      deviceType: 0,
      hashValue: '',
      enabled: false,
      testMode: false,
      gateway: '',
      terminalNum: '',
      allowCredits: false,
      checkForDuplicateTransactions: false,
      visaPaymentTypeID: 0,
      masterPaymentTypeID: 0,
      discoverPaymentTypeID: 0,
      americanPaymentTypeID: 0,
      debitPaymentTypeID: 0,
      interacPaymentTypeID: 0,
      bancontactPaymentTypeID: 0,
      idealPaymentTypeID: 0,
    };
  }

  get retailResponseName() {
    return 'CCGateway';
  }

  /**
   * Return the url for the CCGateway endpoint
   */
  url() {
    let URL = URLHelper.getAccountURL('/CCGateway');
    if (!this.isNew()) {
      URL += `/${this.id}`;
    }
    return `${URL}.json`;
  }

  /**
   * Overridden to parse out the superfluous json that the LSCloud returns us
   * @param response - the json object returned from the fetch call before this object has initialized from it
   * @returns {*} the json object that this object will initialize itself from
   */
  parse(response) {
    // trim out wonky stuff from the response which is present if we fetch a single model
    // but not if it's coming from a collection
    let ccGateway = super.parse(response);

    // the Cloud API has a tendency to send all values as strings so let's make sure they're of the proper type
    ccGateway.tipAmount = Format.parseDecimal(ccGateway.tipAmount);
    ccGateway.ccGatewayID = Format.parseInt(ccGateway.ccGatewayID);
    ccGateway.marketType = Format.parseInt(ccGateway.marketType);
    ccGateway.deviceType = Format.parseInt(ccGateway.deviceType);
    ccGateway.enabled = Format.parseBoolean(ccGateway.enabled);
    ccGateway.testMode = Format.parseBoolean(ccGateway.testMode);
    ccGateway.allowCredits = Format.parseBoolean(ccGateway.allowCredits);
    ccGateway.checkForDuplicateTransactions = Format.parseBoolean(
      ccGateway.checkForDuplicateTransactions
    );
    ccGateway.visaPaymentTypeID = Format.parseInt(ccGateway.visaPaymentTypeID);
    ccGateway.masterPaymentTypeID = Format.parseInt(ccGateway.masterPaymentTypeID);
    ccGateway.discoverPaymentTypeID = Format.parseInt(ccGateway.discoverPaymentTypeID);
    ccGateway.americanPaymentTypeID = Format.parseInt(ccGateway.americanPaymentTypeID);
    ccGateway.debitPaymentTypeID = Format.parseInt(ccGateway.debitPaymentTypeID);
    ccGateway.interacPaymentTypeID = Format.parseInt(ccGateway.interacPaymentTypeID);
    ccGateway.bancontactPaymentTypeID = Format.parseInt(ccGateway.bancontactPaymentTypeID);
    ccGateway.idealPaymentTypeID = Format.parseInt(ccGateway.idealPaymentTypeID);

    return ccGateway;
  }

  /**
   * Initiates a Genius transaction.
   *
   * @param amount {Decimal}  The amount to be transacted.
   * @param saleID {Number}   The ID of the sale for the transaction.
   * @param key {String}      The terminal key
   * @param tipAmount {Decimal} The tipAmount to be transacted.
   *
   * @returns {jQuery.Promise}    Resolves with the Cayan transaction keys.
   */
  createGeniusTransaction(amount, saleID, key) {
    var deferred = $.Deferred();
    var data = {
      amount: Format.formatMoney(amount, 0, false),
      employeeID: window.merchantos.session.getEmployee().employeeID,
      saleID,
      terminalKey: key,
    };

    if (!this.isNew()) {
      $.ajax(`${URLHelper.getAccountURL('/CCGateway')}/${this.id}/GeniusCreateTransaction.json`, {
        type: 'POST',
        data: JSON.stringify(data),
        dataType: 'json',
      })
        .done(response => {
          if (response && response.GeniusTransactionKeys) {
            deferred.resolve(response.GeniusTransactionKeys);
          } else {
            deferred.reject();
          }
        })
        .fail(() => {
          deferred.reject();
        });
    } else {
      console.error('Cannot create a transaction for an unknown gateway.');
      deferred.reject();
    }
    return deferred.promise();
  }
}
